import { render, staticRenderFns } from "./BookGrid.vue?vue&type=template&id=7788fe74&"
import script from "./BookGrid.vue?vue&type=script&lang=js&"
export * from "./BookGrid.vue?vue&type=script&lang=js&"
import style0 from "./BookGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports